export { PayrollQreDetail } from './PayrollQreDetail';
